import React from 'react';
import { Link } from "react-router-dom";

import routes from "../../../constants/Routes";
import GLOBAL from "../../../global";
import { useTenantFeatures } from "../../../features/tenantFeatures/useTenantFeature";

const Header = (props) => {
    const params = new URLSearchParams(window.location.search);
    const srcEncoded = params.get("src");
    const src = decodeURIComponent(srcEncoded);
    const { isAthleteEnabled } = useTenantFeatures();

    return (
        <div className="dashboard-header ">
            <div className="kt-header__brand-logo">
                {
                    isAthleteEnabled ?
                        <a href={`https://atlasathlete.ai/`}>
                            {GLOBAL.LOGO_URL ? (<img src={GLOBAL.LOGO_URL} height="50" alt="MMH Logo"/>) : (
                                <img src={GLOBAL.WHITE_LOGO_URL} height="50" alt="MMH Logo"/>)}
                        </a> :
                        <Link to={isAthleteEnabled ? `${routes.myAssessments}/false` : routes.dashboard}>
                            {GLOBAL.LOGO_URL ? (<img src={GLOBAL.LOGO_URL} height="50" alt="MMH Logo"/>) : (
                                <img src={GLOBAL.WHITE_LOGO_URL} height="50" alt="MMH Logo"/>)}
                        </Link>
                }
            </div>

            {/* Children components passed to Header */}
            {props?.children}
        </div>
    )
};

export default Header;